import type React from 'react';

import { cn } from '@change/ds-utils';

import { useSkeletonContext } from '../context/LoadingSkeletonContext';
import type { SkeletonShapeProps } from '../types';

import { RectangleStyles } from './Rectangle.styles';

export const Rectangle: React.FC<SkeletonShapeProps> = (props) => {
	const { className = '', loading: loadingProp, rounded = false } = props;

	const { loading, shapeColorClassName } = useSkeletonContext();

	const resolvedLoading = loadingProp ?? (loading || false);
	const mergedClassName = cn(shapeColorClassName, className);

	const styles = RectangleStyles({ loading: resolvedLoading, rounded, class: mergedClassName });

	return <div className={styles} />;
};
